import React from 'react';
import { experience } from '../data/mock';
import { Label, Marked } from './primitives';

const Experience = () => (
  <section id="experience" className="bg-cream py-16 sm:py-24 scroll-mt-20">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <Label className="mb-3">Track record</Label>
      <h2 className="text-2xl sm:text-4xl font-bold text-ink tracking-[-0.02em]">
        Founder before. Founder again.
      </h2>
      <p className="mt-3 text-sm sm:text-base text-ink-soft leading-relaxed max-w-2xl">
        I keep starting things. Here's the trail.
      </p>

      <div className="mt-9 sm:mt-10 border-t border-ink">
        {experience.map((exp) => (
          <div
            key={exp.id}
            className="border-b border-rule py-6 grid md:grid-cols-[minmax(0,11rem)_1fr] gap-2 md:gap-8"
          >
            <div>
              <p className="font-mono text-xs text-subtle">{exp.duration}</p>
              {exp.current && (
                <span className="inline-block mt-2 px-2 py-0.5 bg-marker text-ink text-[11px] font-bold rounded">
                  Current
                </span>
              )}
            </div>

            <div>
              <h3 className="text-lg font-bold text-ink tracking-tight">
                {exp.role}
                <span className="text-subtle font-normal"> · </span>
                {exp.url ? (
                  <a
                    href={exp.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-normal text-ink underline decoration-flag decoration-2 underline-offset-2 hover:text-flag transition-colors"
                  >
                    {exp.company}
                  </a>
                ) : (
                  <span className="text-subtle font-normal">{exp.company}</span>
                )}
              </h3>

              <p className="eyebrow mt-1.5">
                {[...new Set([exp.type, exp.location, exp.mode].filter(Boolean))].join(' · ')}
              </p>

              <p className="mt-3 text-sm text-ink-soft leading-relaxed max-w-3xl">
                <Marked text={exp.description} />
              </p>

              {exp.bullets && (
                <ul className="mt-3.5 space-y-2 max-w-3xl">
                  {exp.bullets.map((bullet, i) => (
                    <li key={i} className="flex gap-2.5 text-sm text-ink-soft leading-relaxed">
                      <span className="text-flag select-none mt-[1px]">✦</span>
                      <span>
                        <Marked text={bullet} />
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
